var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgConnectorLine2(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 464,
    height: 196,
    viewBox: "0 0 464 196",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.48796 194.918C7.87849 195.309 8.51165 195.309 8.90218 194.918L15.2661 188.554C15.6567 188.164 15.6567 187.531 15.2661 187.14C14.8756 186.75 14.2424 186.75 13.8519 187.14L8.19507 192.797L2.53821 187.14C2.14769 186.75 1.51452 186.75 1.124 187.14C0.733476 187.531 0.733476 188.164 1.124 188.554L7.48796 194.918ZM463.058 1.43164C463.058 0.879357 462.61 0.431641 462.058 0.431641C461.506 0.43164 461.058 0.879355 461.058 1.43164L463.058 1.43164ZM462.058 71.1139H463.058H462.058ZM9.19507 194.211V119.114H7.19507V194.211H9.19507ZM32.1951 96.1139H438.058V94.1139H32.1951V96.1139ZM463.058 71.1139L463.058 1.43164L461.058 1.43164L461.058 71.1139H463.058ZM438.058 96.1139C451.865 96.1139 463.058 84.921 463.058 71.1139H461.058C461.058 83.8165 450.761 94.1139 438.058 94.1139V96.1139ZM9.19507 119.114C9.19507 106.411 19.4925 96.1139 32.1951 96.1139V94.1139C18.3879 94.1139 7.19507 105.307 7.19507 119.114H9.19507Z",
    fill: "#9D9D9D"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgConnectorLine2);
export default __webpack_public_path__ + "static/media/connector-line2.a81990e94291d4896214ed22f10eadaf.svg";
export { ForwardRef as ReactComponent };